import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaPage } from '../utils/metaPixel';

export default function MetaPageTracking() {
  const { pathname } = useLocation();
  useEffect(() => { trackMetaPage(pathname); }, [pathname]);
  return null;
}
